import { Section } from "/components/Layout";
import Image from "/components/cms/image";
import Video from "components/Video";

type Props = {
  data: {
    _type: string;
    videoUrl: string;
    asset: any;
    size: string;
    block: string;
  }[];
};
// Format content from Sanity CMS
const HeaderMedia = ({ data }: Props) => {
  const { _type: block = "" } = data[0];

  if (block === "video") {
    return (
      <Section center inner="small">
        <Video url={data[0].videoUrl} />
      </Section>
    );
  }

  if (block === "image") {
    const { size } = data[0];
    const noLimit = size === "large";

    return (
      <Section outer="xsmall" limitedWidth outerNoLimit={noLimit}>
        <Image imageObject={data[0]} />
      </Section>
    );
  }

  console.error("No header media configured for block type:", block);
  return null;
};

export default HeaderMedia;
